
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :

import Background from '../../../components/background/Background.jsx'
import Comments from '../../../components/comments/Comments.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx'
import ManagerMenu from '../../../components/managermenu/ManagerMenu.jsx'
import PanierList from '../../../components/location/panierList/PanierList.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";


// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircularProgress from '@mui/material/CircularProgress';
import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EuroIcon from '@mui/icons-material/Euro';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import CloseIcon from '@mui/icons-material/Close';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

//Utils
import { checkLogin } from '../../../utils/check-login.js'
import setNumResa from '../../../utils/set_num_resa.js'; //params : resaInfos
import convertHoraire from '../../../utils/convert_horaire.js';
import sortElevesCreneaux from '../../../utils/sort-eleves-creneaux.js';


function ManagerLocations() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();


    let [searchFilter, setSearchFilter] = useState("");
    let [listSorter, setListSorter] = useState({ type: "date", sens: "asc" });
    let [locList, setLocList] = useState([]);
    let [filteredLocs, setFilteredLocs] = useState([]);
    let [showInfos, setShowInfos] = useState([]);
    const [dbArticles, setDbArticles] = useState([])
    const [dbTailles, setDbTailles] = useState([])
    const [matchOnly, setMatchOnly] = useState(true)


    let isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
    dayjs.extend(isSameOrAfter)
    let isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
    dayjs.extend(isSameOrBefore)

    //// -- at first render :
    useEffect(() => {


        if (checkLogin() === false) {

            navigate(`/manager/login?dest=manager/locations`)
        }

        async function initLocations() { //we add this inner function to manage asynchrone
            let allLocs = await getAllLocs();
            setLocList(allLocs);

            setFilteredLocs(allLocs.filter(loc => !(loc.match === false && loc.created !== loc.updatedAt)));

        } //end of async function


        initLocations(); //call the inner asnchrone function

        async function initArticles() {
            const resp = await axios.get(`${baseURL}/article`);
            setDbArticles(resp.data);

            initTailles()
        }
        initArticles()

        async function initTailles() {
            const resp = await axios.get(`${baseURL}/taille`);
            setDbTailles(resp.data);
        }

    }, [])

    useEffect(() => {
        if (matchOnly === true) {
            setFilteredLocs(locList.filter(loc => !(loc.match === false && loc.created !== loc.updatedAt)));
        } else {
            setFilteredLocs(locList);
        }

    }, [matchOnly])
    //// -- 

    async function getAllLocs() { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/location/all/infos`,
            });
            //console.log(response);
            const locs = response.data;
            return locs;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    const today = dayjs(); // set the date of the current day

    function filterLocs(word) {
        console.log(word);

        switch (word) {
            case "match":
                // code block
                setSearchFilter(word);
                setFilteredLocs(locList.filter((loc) => (loc.match === true)));
                break;
            case "unmatch":
                // code block
                setSearchFilter(word);
                setFilteredLocs(locList.filter((loc) => (loc.match === false)));
                break;
            case "paid":
                // code block
                setSearchFilter(word);
                setFilteredLocs(locList.filter((loc) => (loc.solde === 0)));
                break;
            case "unpaid":
                // code block
                setSearchFilter(word);
                setFilteredLocs(locList.filter((loc) => (loc.solde > 0)));
                break;


            default:
                // code block
                setFilteredLocs(locList.filter((loc) =>
                    (loc.ref_location === word || String(loc.id_location) === word || loc.Client.nom.toLowerCase() === word.toLowerCase() || loc.Client.tel === word || loc.Client.prenom.email === word.toLowerCase())
                ));
        }



    }

    function sortLocs(list) {

        return list.toSorted((c1, c2) => dayjs(c1.d1).isBefore(dayjs(c2.d1)));

    }



    function getBtClass(type) {
        let laClass = "manager-reservations-top-searchbar-btsort"

        laClass += type === listSorter.type ? " selected-sorter " : " "

        return laClass;

    }

    function infosShower(id) {
        //let temp = showInfos;
        let temp = [];
        let coche = false;
        if (showInfos[id]) { coche = !showInfos[id]; }
        else { coche = true; }
        temp[id] = coche;
        setShowInfos(temp);

    }

    function checkFinished(loc) {
        let passee = dayjs().isAfter(dayjs(loc.d2), "day")
        return passee;

    }

    function checkStarted(loc) {
        let started = dayjs().isSameOrAfter(dayjs(loc.d1), "day")
        return started;

    }

    function getNoMatchInfos(loc) {
        //quand on arrive ici le match est à false
        if (loc.created !== loc.updatedAt) { // yann est intervenue
            return (<><CloseIcon /> {"Refusée"}</>)/*  */;
        } else {
            return (<><AlarmOnIcon /> {"En attente"}</>)/*  */;
        }



    }

    function getItemBgClass(loc) {
        let laClass = "manager-reservations-bottom-list-item";
        laClass += checkFinished(loc) ? " bg-finished " : "";
        laClass += checkStarted(loc) ? " bg-started " : "";
        return laClass;
    }

    function getLocDates(loc) {
        let deb = dayjs(loc.d1).format("DD/MM");
        let fin = dayjs(loc.d2).format("DD/MM");
        return deb + " -> " + fin;
    }


    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <ManagerMenu current="locations" />

                    <div className="manager-reservations">
                        <h1>Locations matériel</h1>
                        <div className="manager-reservations-top">
                            <div className="manager-reservations-top-searchbar">
                                <div>

                                    {/* <span
                                        className={"manager-reservations-top-searchbar-sort-match " + (searchFilter === "match" ? " sort-btn-pink " : " ") + (searchFilter === "unmatch" ? " sort-btn-black " : " ")}
                                        onClick={_ => { filterLocs(searchFilter === "match" ? "unmatch" : "match") }}>
                                        <CheckIcon />
                                    </span>
                                    <span
                                        className={"manager-reservations-top-searchbar-sort-paid " + (searchFilter === "paid" ? " sort-btn-green " : " ") + (searchFilter === "unpaid" ? " sort-btn-black " : " ")}
                                        onClick={_ => { filterLocs(searchFilter === "paid" ? "unpaid" : "paid") }}>
                                        <EuroIcon />
                                    </span> */}
                                </div>
                                <div>
                                    <FormControlLabel
                                        control={<Checkbox />}
                                        checked={!matchOnly}
                                        label="Afficher aussi les demandes refusées"
                                        onChange={(event) => setMatchOnly(!event.target.checked)}
                                    />
                                </div>


                            </div>

                        </div>

                        <div className="manager-reservations-bottom">


                            {locList.length > 0 ?
                                <div className="manager-reservations-bottom-list">
                                    {sortLocs(filteredLocs).map((loc) =>

                                        <section key={loc.id_location}>
                                            <div className={getItemBgClass(loc)} onClick={_ => infosShower(loc.id_location)}>
                                                <div>
                                                    <p className={loc.match === true ? loc.solde === 0 ? "resa-item-numresa resa-item-numresa-paid" : "resa-item-numresa resa-item-numresa-match" : "resa-item-numresa"}>{loc.ref_location}</p>
                                                    <p className={loc.coupon > 0 ? "resa-item-tarif resa-item-tarif-coupon" : "resa-item-tarif"}>{Math.round((100 - loc.coupon) / 100 * loc.total)},00€ {loc.coupon > 0 ? `(${loc.coupon}%)` : ""}</p>
                                                </div>
                                                <div>
                                                    <p>{getLocDates(loc)}</p>
                                                    <p>{loc.Client.nom} {loc.Client.prenom}</p>
                                                </div>
                                                <div>
                                                    {loc.match === true ? <span className="resa-item-match"> <CheckIcon /></span> :
                                                        <span className={loc.created === loc.updatedAt ? "resa-item-nomatch-client" : "resa-item-nomatch-atall"}>{getNoMatchInfos(loc)}</span>}
                                                    {loc.solde === 0 ? <span className="resa-item-euro"> <EuroIcon /></span> : null}
                                                    <p>{dayjs(loc.created).format("DD/MM/YYYY")}</p>
                                                </div>
                                            </div>
                                            {showInfos[loc.id_location] === true ?
                                                <div className="manager-reservations-bottom-list-infos">

                                                    <div className="manager-reservations-bottom-accordeon-intro">
                                                        <div className="manager-reservations-bottom-accordeon-intro-left">
                                                            <div className="manager-reservations-bottom-accordeon-intro-date">
                                                                <p>Date de création : {dayjs(loc.created).format("DD/MM/YYYY")}</p>
                                                                {loc.match === false ? loc.created !== loc.updatedAt ? <h5>no match</h5> : <h5>En attente</h5> : null}
                                                            </div>

                                                            <div className="manager-reservations-bottom-accordeon-intro-tarifs">
                                                                <h4>Tarif : {loc.total},00€</h4>
                                                                {loc.solde === 0 ? <p>Payé en ligne</p> : null}
                                                            </div>
                                                        </div>
                                                        <div className="manager-reservations-bottom-accordeon-intro-right">
                                                            <p>{loc.Client.prenom} {loc.Client.nom}</p>
                                                            <p>{loc.Client.tel}</p>
                                                            <p>{loc.Client.email}</p>
                                                        </div>

                                                    </div>

                                                    <PanierList dbArticles={dbArticles} dbTailles={dbTailles} panierAMatcher={loc.Paniers} locAMatcher={loc} />

                                                    <div className="manager-reservations-bottom-accordeon-commentaires">
                                                        <h3>Commentaires :</h3>
                                                        <div className="manager-reservations-bottom-accordeon-commentaires-list">
                                                            <p>le client a dit :{loc.commentaire.split('&&')[0]}</p>
                                                            <p>Wally a répondu :{loc.commentaire.split('&&')[1]}</p>

                                                        </div>

                                                    </div>
                                                </div>
                                                : null}
                                        </section>

                                    )}
                                </div>
                                :
                                <CircularProgress />
                            }

                        </div>



                    </div>



                </div>
            </main>
        </div>
    );
}

export default ManagerLocations;